import { Container, IDestroyOptions, Sprite } from "pixi.js";
import { CommonResourcesPackage } from "../resources/CommonResourcesPackage";
import { gsap, Power1 } from "gsap";
type TimeLine = gsap.core.Timeline;

export class Hand extends Container {
    private static readonly DEFAULT_HAND_ANGLE = 20;
    private static readonly HAND_SPRITE_ANGLE_OFFSET = -20;
    private static readonly HAND_PULSE_ANIMATION_TIME = 0.6;
    private static readonly HAND_PULSE_RANGE = 70;

    private handSprite: Sprite;
    private handAnimation: TimeLine;

    public constructor(commonResources: CommonResourcesPackage) {
        super();
        this.handSprite = new Sprite(commonResources.assets_common_ui_hand_hand_png);
        this.handSprite.angle = Hand.HAND_SPRITE_ANGLE_OFFSET;
        this.addChild(this.handSprite);
        this.angle = Hand.DEFAULT_HAND_ANGLE;
        this.handAnimation = gsap.timeline({ repeat: -1, yoyo: true });
        this.handAnimation.to(this.handSprite, { y: this.handSprite.y + Hand.HAND_PULSE_RANGE, duration: Hand.HAND_PULSE_ANIMATION_TIME, ease: Power1.easeInOut });
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.handAnimation?.kill();
        super.destroy(options);
    }
}
